import $ from 'jquery';

export default {
	init() {
        "use strict";
        	
        var firsttabcontent = document.getElementsByClassName("tabcontent");
        $(firsttabcontent[0]).addClass('active');

        $('ul.popular-tab li').on("click", function() {
            var tab_id = $(this).attr('data-tab');
    
            $('ul.popular-tab li').removeClass('active');
            $('.tabcontent').removeClass('active');
    
            $(this).addClass('active');
            $("#"+tab_id).addClass('active');
        })

	},
};
